// @flow
import { handleResponseOld, makeGet } from './helpers';
import shuffle from 'lodash/shuffle';

const transform = body => {
    if (body.payload?.itemIDs) {
        body.payload.itemIDs = shuffle(body.payload.itemIDs);
    }
    return {
        error: body.error,
        payload: body.payload,
    };
};

type FetchCategoryResultsParams = {
    authToken: string,
    deployment: string,
    ids: any,
    searchQuery: any,
};

type FetchPromotedSearchResultsParams = {
    authToken: string,
    deployment: string,
    ids?: any,
    searchQuery: any,
};

type FetchSearchFacetsResultsParams = {
    authToken: string,
    deployment: string,
    searchQuery: any,
};

type FetchSearchResultsParams = {
    authToken: string,
    deployment: string,
    geoCoordinates: any,
    searchQuery: any,
    useGeoLocation: boolean,
};

export default {
    // this is search ... need to adjust to use the category landing page endpoint
    fetchCategoryResults: ({ authToken, deployment, ids, searchQuery }: FetchCategoryResultsParams) =>
        new Promise<any>((resolve, reject) => {
            const encodedIds = encodeURIComponent(JSON.stringify(ids));
            let buyNow = '';
            if (searchQuery.buyNow) {
                buyNow = `&buyNow=${encodeURIComponent(JSON.stringify(searchQuery.buyNow))}`;
                delete searchQuery.buyNow;
            }
            let searchString = `<SEARCH-API>?ids=${encodedIds}${buyNow}`;
            const encodedParams = encodeURIComponent(JSON.stringify(searchQuery));
            searchString = `${searchString}&parameters=${encodedParams}`;

            const request = makeGet({ apiPath: 'categoryweb', authToken, deployment, path: searchString });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchPromotedSearchResults: ({ authToken, deployment, ids, searchQuery }: FetchPromotedSearchResultsParams) =>
        new Promise<any>((resolve, reject) => {
            // temp for phased rollout of search
            let searchString = `<SEARCH-API>?promoted=1&parameters=${encodeURIComponent(JSON.stringify(searchQuery))}`;

            let apiPath = 'web';
            if (ids && ids.length) {
                searchString = `${searchString}&ids=${encodeURIComponent(JSON.stringify(ids))}`;
                apiPath = 'categoryweb';
            } else if (searchQuery.campaignId && searchQuery.campaignId > 0) {
                searchString = `${searchString}&ids=${encodeURIComponent('[]')}`;
                apiPath = 'categoryweb';
            }

            const request = makeGet({ apiPath, authToken, deployment, path: searchString });

            request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
        }),
    fetchSearchFacetsResults: ({ authToken, deployment, searchQuery }: FetchSearchFacetsResultsParams) =>
        new Promise<any>((resolve, reject) => {
            let searchString = `<SEARCH-API>?parameters=${encodeURIComponent(JSON.stringify(searchQuery))}`;

            const request = makeGet({
                apiPath: 'faceted',
                authToken,
                deployment,
                path: searchString,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchSearchResults: ({
        authToken,
        deployment,
        geoCoordinates,
        searchQuery,
        useGeoLocation = false,
    }: FetchSearchResultsParams) =>
        new Promise<any>((resolve, reject) => {
            let buyNow = '';
            if (searchQuery.buyNow) {
                buyNow = `&buyNow=${encodeURIComponent(JSON.stringify(searchQuery.buyNow))}`;
                delete searchQuery.buyNow;
            }
            if (useGeoLocation) {
                searchQuery.useGeo = true;
            }

            if (Boolean(geoCoordinates?.latitude) && Boolean(geoCoordinates?.longitude)) {
                searchQuery.lat = `${geoCoordinates.latitude}`;
                searchQuery.long = `${geoCoordinates.longitude}`;
            }

            let searchString = `<SEARCH-API>?parameters=${encodeURIComponent(JSON.stringify(searchQuery))}${buyNow}`;
            const request = makeGet({ apiPath: 'web', authToken, deployment, path: searchString, useCacheKey: false });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
